import React, { useState } from 'react';
import styles from './TermModal.module.css';

import { InnocodePaymentCardInfo, InnocodePaymentPasswordButton, InnocodePaymentPasswordDot } from '@intsoft/innocode-payment';
import { useDialog, InnocodeLoading } from '@intsoft/innocode-core';

/* 비밀번호 입력/생성/수정 모달 */
interface TermModalProps {
    // 약관 제목
    title?: string;
    // html 형태의 term 원문
    content?: string;
    isOpen: boolean;
    onClose: () => void;
}

export const TermModal: React.FC<TermModalProps> = (props: TermModalProps) => {

    return (
        <div className={styles.layoutContainer}>
            <div className={styles.scrollContentArea}>
                <div className={styles.minHeightArea}>
                    <div className={styles.contentAreaWrapper}>
                        <div className={styles.contentArea}>
                            <div className={styles.contentAreaTitle}>
                                <h1 className={`innocode-typography--headline-sm innocode-typography--bold ${styles.contentAreaTitleText}`}>
                                    {props.title}
                                </h1>
                                <svg onClick={props.onClose} className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
                                </svg>
                            </div>
                            <div className={styles.termArea}>
                                <div dangerouslySetInnerHTML={{ __html: props.content || '' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};